import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
  Form, Typography, Checkbox, Button, Space, Modal, Row, Input, Select, InputNumber, message, Spin, Divider, Tooltip,
} from 'antd'

import { DollarCircleFilled, CreditCardOutlined } from '@ant-design/icons'

import { useRecoilState } from 'recoil'

import { fetch } from '../../../utils/fetch'
import {
  roundingState, totalPriceState, discountPriceState, netPriceState, discountTypeState, sumPaymentState,
} from '../../../store/atoms'

import PaymentModal from '../../component/PaymentModal'

const DiscountTotalSoPrice = ({
  orderId, orderType, created = false, soNumber = '',
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])
  const [maxVal, setMaxVal] = useState(0)
  const [totalPrice, setTotalPrice] = useRecoilState(totalPriceState)
  const [discountPrice, setDiscountPrice] = useRecoilState(discountPriceState)
  const [discountType, setDiscountType] = useRecoilState(discountTypeState)
  const [netPrice, setNetPrice] = useRecoilState(netPriceState)
  const [rounding, setRounding] = useRecoilState(roundingState)
  const [sumPayment] = useRecoilState(sumPaymentState)
  const [visible, setVisible] = useState(false)
  const [paymentVisible, setPaymentVisible] = useState(false)

  const [form] = Form.useForm()

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  }

  useEffect(() => {
    form.setFieldsValue({
      discountType: 'percent',
      discountValue: 0,
      username: '',
      password: '',
    })
  }, [visible])

  const getOrderItems = () => {
    if (orderType) {
      setIsLoading(true)
      fetch({
        method: 'GET',
        url: `/order/${orderId}/item/${orderType}/SO_SAP`,
      }).then((res) => {
        const dataItems = res?.data?.data
        if (dataItems) {
          const dataAddKey = dataItems.map((val) => {
            const newValue = val
            newValue.key = val?.orderItemId
            return newValue
          })
          // console.log(dataAddKey)
          setData(dataAddKey)
          sumTotalPriceItem(dataAddKey)
        }
      })
    }
  }

  const numberWithCommas = (price) => {
    if (!isNaN(price)) return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return '-'
  }

  const sumTotalPriceItem = (data) => {
    // console.log(data)
    let sumPrice = 0
    data.map((items) => {
      sumPrice += (Number(items.itemUnitPrice) * Number(items.itemQty))
    })
    const calculatedPrice = Number(sumPrice).toFixed(2)
    setTotalPrice(Number(calculatedPrice))
    setNetPrice(Number(calculatedPrice))
    setDiscountPrice(0)
    setDiscountType(null)
    setIsLoading(false)
  }

  const checkAuthen = (values) => {
    // console.log('checksentsap', values)
    fetch({
      method: 'POST',
      url: '/authentication/sap/discount',
      data: {
        username: values.username,
        password: values.password,

      },
    }).then((res) => {
      if (res?.data?.success) {
        calDiscount(values)
        setVisible(!visible)
      } else {
        message.error(res?.data?.message)
      }
    })
  }

  const calDiscount = (values) => {
    let sumPrice = 0
    let discount = 0
    let calculatedPrice = 0
    console.log('data', values)
    data.map((items) => {
      sumPrice += (Number(items.itemUnitPrice) * Number(items.itemQty))
    })
    if (values.discountType === 'percent') {
      const discountVal = values.discountValue > 100 ? 100 : values.discountValue
      discount = Number((sumPrice * discountVal) / 100).toFixed(2)
      calculatedPrice = (Number(sumPrice) - ((sumPrice * discountVal) / 100)).toFixed(2)
    }
    if (values.discountType === 'flat') {
      console.log(values.discountValue)
      const discountVal = values.discountValue > totalPrice ? totalPrice : values.discountValue
      discount = Number(discountVal).toFixed(2)
      calculatedPrice = (Number(sumPrice) - discountVal).toFixed(2)
    }
    setDiscountType(values.discountType || null)
    setDiscountPrice(Number(values.discountValue))
    setNetPrice(Number(calculatedPrice))
  }

  useEffect(() => {
    if (created) {
      setIsLoading(false)
    } else {
      getOrderItems()
    }
  }, [orderId, orderType])

  if (created) {
    return (
      <>
        <Spin spinning={isLoading} tip="Loading...">
          <Space direction="vertical" align="end">
            <Form
              form={form}
              size="small"
              style={{ paddingRight: '16px' }}
            >
              <Form.Item
                name="totalPrice"
                label="Total Price"
              >
                <Typography.Text style={{ float: 'right' }} className="ant-form-text" type="secondary">
                  {numberWithCommas(totalPrice)} THB
                </Typography.Text>
              </Form.Item>
              <Form.Item
                name="discount"
                label="Discount"
              >
                <Typography.Text style={{ float: 'right' }} className="ant-form-text" type="secondary">
                  {numberWithCommas(discountPrice) || 0.00} THB
                </Typography.Text>
              </Form.Item>
              <Form.Item
                name="netPrice"
                label="Net Price"
              >
                <Typography.Text style={{ float: 'right' }} className="ant-form-text">
                  {numberWithCommas(netPrice) || 0.00} THB
                </Typography.Text>
              </Form.Item>
              {
                created
                && (
                <>
                  <Divider />
                  <Form.Item
                    label={(
                      <Space>
                        <Tooltip title="Payment Transaction">
                          <Button icon={<CreditCardOutlined />} onClick={() => setPaymentVisible(!visible)} />
                        </Tooltip>
                        <span>Paid</span>
                      </Space>
                    )}
                  >
                    <Typography.Text style={{ float: 'right' }} className="ant-form-text" type={sumPayment === netPrice && 'success'}>
                      {numberWithCommas(sumPayment) || 0.00} THB
                    </Typography.Text>
                  </Form.Item>

                </>
                )
              }
            </Form>
          </Space>
        </Spin>
        <PaymentModal
          visible={paymentVisible}
          onCancel={() => {
            setPaymentVisible(false)
          }}
          soNumber={soNumber}
        />
      </>
    )
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <Space direction="vertical" align="end">
          <Form
            name="totalPrice"
            className="login-form"
            size="small"
            style={{ paddingRight: '16px' }}
          >

            <Form.Item
              name="totalPrice"
              label="Total Price"
            >
              <Typography.Text style={{ float: 'right' }} className="ant-form-text" type="secondary">
                {numberWithCommas(totalPrice)} THB
              </Typography.Text>
            </Form.Item>
            <Form.Item
              name="discount"
              label={(
                <Space>
                  Discount
                  <Button style={{ float: 'right' }} type="primary" icon={<DollarCircleFilled />} onClick={() => setVisible(!visible)} />
                </Space>
              )}
            >
              <Typography.Text style={{ float: 'right' }} className="ant-form-text" type="secondary">
                {numberWithCommas(discountPrice) || 0.00} {discountType === 'percent' ? '%' : 'THB'}
              </Typography.Text>
            </Form.Item>
            <Form.Item
              name="netPrice"
              label="Net Price"
            >
              <Typography.Text style={{ float: 'right' }} className="ant-form-text">
                {numberWithCommas(netPrice) || 0.00} THB
              </Typography.Text>
            </Form.Item>
            <Form.Item
              name="rounding"
              label="Rounding"
            >
              <Checkbox value={rounding} onClick={(e) => setRounding(e.target.checked)} style={{ float: 'right', paddingRight: '8px' }} />
            </Form.Item>
          </Form>

        </Space>

        <Modal
          title="Discount"
          visible={visible}
          maskClosable={false}
          okText="Submit"
          cancelText="Cancel"
          onCancel={() => { setVisible(!visible) }}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                console.log(values.discountValue)

                checkAuthen(values)
              })
              .catch((info) => {
                console.log('Validate Failed:', info)
              })
          }}
        >
          <Form
            name="discountModal"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 14 }}
            layout="horizontal"
            form={form}
            {...layout}
            size="small"
          >
            <Form.Item
              label="Discount Type"
              name="discountType"
            >
              <Select>
                <Select.Option value="percent">%</Select.Option>
                <Select.Option value="flat">THB</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Discount"
              name="discountValue"
              rules={[
                {
                  required: true, message: 'Please input Discount Value!',
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                min={0}
                defaultValue={0}
                precision={2}
                formatter={(value) => (form.getFieldValue('discountType') === 'flat' ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : `${value}%`)}
                parser={(value) => (form.getFieldValue('discountType') === 'flat' ? value.replace(/\$\s?|(,*)/g, '') : value.replace('%', ''))}
                onChange={() => (form.getFieldValue('discountType') === 'flat' ? setMaxVal(Number(totalPrice)) : setMaxVal(100))}
                max={maxVal}
              />
            </Form.Item>
            <Form.Item
              label="Username"
              name="username"
              rules={[{ required: true, message: 'Please input your username!' }]}
            >
              <Input autocomplete="off" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password autocomplete="off" />
            </Form.Item>
          </Form>
        </Modal>
      </Spin>
    </>
  )
}

export default DiscountTotalSoPrice

DiscountTotalSoPrice.propTypes = {
  data: PropTypes.string.isRequired,
}
